<template>
  <div class="base-box">
    <!-- 附件上传 -->
    <h3>
      <van-icon name="upgrade" color="#228ccd" />附件上传
    </h3>
    <p class="warm">注：文件大小不超过6M，支持 jpg 和 png 格式；</p>
    <div class="base-item">
      <h4>
        上传证明材料
        <span>职称证明材料请上传图片</span>
      </h4>
      <van-uploader v-model="fileList" :after-read="afterTitleFile" @delete="delFile('titleFileId')" :max-count="1" />
    </div>
    <div class="base-item">
      <h4>
        2寸证件照
        <span>照片仅用于制作会员证书</span>
      </h4>
      <van-uploader v-model="fileList2" :after-read="afterPortraitFile" @delete="delFile('portraitId')"
        :max-count="1" />
    </div>
    <!-- 基本信息 -->
    <h3>
      <van-icon name="orders-o" color="#228ccd" />基本信息
    </h3>
    <div class="base-item">
      <van-cell class="input-item" title="会员类型" :value="memberName" required is-link
        @click="setSelectModel('memberTypeList2','dueName','memberType')" />
    </div>
    <div class="base-item">
      <van-field class="input-item" label="真实姓名" v-model="params.name" required clearable placeholder="请输入真实姓名" />
    </div>
    <div class="base-item">
      <van-cell class="input-item" title="性别" :value="gender" required is-link
        @click="setSelectModel('GENDER','name','gender')" />
    </div>
    <div class="base-item">
      <van-cell class="input-item" title="生日" :value="birthday" required is-link
        @click="setSelectModel('birthday','birthday','birthday')" />
    </div>
    <div class="base-item">
      <van-field class="input-item" label="毕业院校" v-model="params.school" clearable placeholder="请输入毕业院校" />
    </div>
    <div class="base-item">
      <van-field class="input-item" label="所学专业" v-model="params.major" clearable placeholder="请输入所学专业" />
    </div>
    <div class="base-item">
      <van-cell class="input-item" title="政治面貌" :value="getName('POLITICAL_STATUS','partisan')" required is-link
        @click="setSelectModel('POLITICAL_STATUS','name','partisan')" />
    </div>
    <div class="base-item">
      <van-cell class="input-item" title="工作性质" :value="getName('WORK_NATURE','workNature')" is-link
        @click="setSelectModel('WORK_NATURE','name','workNature')" />
    </div>
    <div class="base-item">
      <van-field class="input-item" label="工作单位" v-model="params.company" required clearable placeholder="请输入工作单位" />
    </div>
    <div class="base-item">
      <van-field class="input-item" label="社会任职" v-model="params.socialTenure" required clearable
        placeholder="请输入社会任职" />
    </div>
    <div class="base-item">
      <van-cell class="input-item" title="职称" :value="getName('zhichengList','title')" required is-link
        @click="setSelectModel('zhichengList','label','title', true)" />
    </div>
    <div class="base-item">
      <van-cell class="input-item" title="学历" :value="getName('EDUCATION','education')" required is-link
        @click="setSelectModel('EDUCATION','name','education')" />
    </div>
    <div class="base-item">
      <van-cell class="input-item" title="学位" :value="getName('DEGREE','degree')" required is-link
        @click="setSelectModel('DEGREE','name','degree')" />
    </div>
    <div class="base-item">
      <van-cell class="input-item" title="证件类别" :value="getName('ID_TYPE','idType')" required is-link
        @click="setSelectModel('ID_TYPE','name','idType')" />
    </div>
    <div class="base-item">
      <van-field class="input-item" label="证件号码" v-model="params.idNumber" required clearable placeholder="请输入证件号码" />
    </div>
    <div class="base-item">
      <van-cell class="input-item" title="民族" :value="getName('NATIONALITY','nationality')" required is-link
        @click="setSelectModel('NATIONALITY','name','nationality')" />
    </div>
    <div class="base-item">
      <van-cell class="input-item" title="籍贯" :value="jgName || '内容'" required is-link @click="setCity('jg','name')" />
    </div>
    <div class="base-item">
      <van-field class="input-item" label="工作专业" v-model="params.workMajor" clearable placeholder="请输入工作专业" />
    </div>
    <div class="base-item">
      <van-field class="input-item" label="业务成绩" type="textarea" v-model="params.jobPerformance" clearable
        placeholder="请输入您的业务成绩" />
    </div>
    <!-- 联系方式 -->
    <h3>
      <van-icon name="phone-o" color="#228ccd" />联系方式
    </h3>
    <div class="base-item">
      <van-cell class="input-item" title="所在地区" :value="addName || '内容'" required is-link
        @click="setCity('add','name')" />
    </div>
    <div class="base-item">
      <van-field class="input-item" type="textarea" v-model="params.fullAddress" required clearable
        placeholder="请输入您的详细地址" />
    </div>
    <div class="base-item">
      <van-field class="input-item" label="邮政编码" v-model="params.zipcode" clearable placeholder="请输入邮政编码" />
    </div>
    <div class="base-item">
      <van-field class="input-item" label="电子邮箱" v-model="params.email" required clearable placeholder="请输入电子邮箱" />
    </div>
    <div class="base-item">
      <van-field class="input-item" label="手机号码" v-model="params.mobile" required clearable placeholder="请输入手机号码" />
    </div>
    <div class="base-item">
      <van-field class="input-item" label="座机电话" v-model="params.telephone" clearable placeholder="请输入座机电话" />
    </div>
    <!-- 会员信息 -->
    <h3>
      <van-icon name="phone-o" color="#228ccd" />会员信息
    </h3>
    <div class="base-item">
      <van-cell class="input-item" title="加入分会或总会" :value="getName('branchsList','recommendUnitId')" is-link required
        @click="setSelectModel('branchsList','name','recommendUnitId')" />
    </div>
    <div class="base-item">
      <van-cell class="input-item" title="关注单位" :value="getName('branchsList','concernUnitId')" is-link
        @click="setSelectModel('branchsList','name','concernUnitId')" />
    </div>
    <div class="base-item">
      <van-field class="input-item" type="textarea" v-model="params.experience" required clearable
        placeholder="请输入您的教育及工作经历" />
    </div>
    <div class="base-item">
      <van-field class="input-item" type="textarea" v-model="params.achievement" clearable
        placeholder="请输入您有何发明、著作学术论文（何时何地出版发表）及科普先进事迹" />
    </div>
    <div class="base-item">
      <van-field class="input-item" type="textarea" v-model="params.awards" clearable placeholder="请输入您受过何种奖励" />
    </div>
    <van-button class="nextBtn" type="primary" size="large" @click="next">下一步</van-button>

    <!-- 选择弹窗 -->
    <van-popup v-model="selectModel" position="bottom" :style="{ 'min-height': '20%' }">
      <template v-if="selectKey === 'birthday'">
        <van-datetime-picker :value="params.birthday" type="date" :min-date="minDate" @cancel="onCancel"
          @confirm="onConfirmDate" />
      </template>
      <template v-else>
        <van-picker show-toolbar ref="picker" :value-key="key" :columns="columns" @change="onChange" @cancel="onCancel"
          @confirm="onConfirm" />
      </template>
    </van-popup>
  </div>
</template>

<script>
  import {
    Icon,
    Uploader,
    Field,
    Cell,
    CellGroup,
    Button,
    Popup,
    Picker,
    DatetimePicker,
    Toast
  } from "vant";
  import { mapState, mapGetters, mapActions } from "vuex";
  import { uploadFile, delFile } from "@/api/upload";
  import { registerMemberEdit } from "@/api/login";

  export default {
    data() {
      return {
        fileList: [],
        fileList2: [],
        selectModel: false,
        params: {
          memberType: null,
          name: "",
          gender: null,
          birthday: new Date(),
          partisan: "",
          workNature: "",
          title: "",
          education: "",
          degree: "",
          idType: "",
          nationality: "",
          recommendUnitId: "",
          concernUnitId: "",
          nativeProvince: "",
          nativeCity: "",
          province: "",
          city: "",
          titleFileId: null,
          portraitId: null,
          school: "",
          major: "",
          company: "",
          socialTenure: "",
          idNumber: "",
          workMajor: "",
          jobPerformance: "",
          fullAddress: "",
          zipcode: "",
          email: "",
          mobile: "",
          telephone: "",
          experience: "",
          achievement: "",
          awards: ""
        },
        key: "", //选择弹窗显示对应的参数名
        selectKey: "", //所选择的字段
        titleGroup: "", //职称第一列的数据
        jgName: "",
        addName: "",
        columns: [],
        request: {
          // titleFileId: "请上传您的证明材料",
          portraitId: "请上传您的证件照",
          memberType: "请选择会员类型",
          name: "请输入您的姓名",
          gender: "请选择您的性别",
          birthday: "请选择您的出生年月",
          partisan: "请选择您的政治面貌",
          company: "请输入您的工作单位",
          // socialTenure: "请输入您的社会任职",
          // title: "请选择您的职称",
          education: "请选择您的学历",
          degree: "请选择您的学位",
          idType: "请选择证件类别",
          idNumber: "请输入证件号码",
          nationality: "请选择您的民族",
          nativeProvince: "请选择您的籍贯",
          nativeCity: "请选择您的籍贯",
          fullAddress: "请输入您的通讯地址",
          email: "请输入您的常用邮箱",
          mobile: "请输入您的手机号码"
        },
        memberTypeList2: [
          { dueName: "普通会员", memberType: 1, memberTypeText: "普通会员" },
          { dueName: "学生会员", memberType: 2, memberTypeText: "学生会员" },
        ],
      };
    },
    components: {
      [Cell.name]: Cell,
      [CellGroup.name]: CellGroup,
      [Icon.name]: Icon,
      [Uploader.name]: Uploader,
      [Field.name]: Field,
      [Button.name]: Button,
      [Popup.name]: Popup,
      [Picker.name]: Picker,
      [DatetimePicker.name]: DatetimePicker
    },
    watch: {
      "params.birthday"(date) {
        console.log(date);
      }
    },
    props: {
      member: {
        type: Object,
        default: () => { }
      }
    },
    computed: {
      ...mapState(["memberTypeList", "branchsList", "zhichengList", "cityList"]),
      ...mapGetters([
        "GENDER",
        "POLITICAL_STATUS",
        "EDUCATION",
        "DEGREE",
        "WORK_NATURE",
        "ID_TYPE",
        "NATIONALITY"
      ]),
      minDate() {
        return new Date("1960");
      },
      //会员类型名称
      memberName() {
        let id = this.params.memberType;

        if (!id) {
          return "内容";
        } else {
          let obj = this.memberTypeList.find(item => item.memberType === id);
          return obj.dueName;
        }
      },
      gender() {
        let id = this.params.gender;
        if (!id && id !== 0) {
          return "内容";
        } else {
          let obj = this.GENDER.find(item => item.value === id);
          return obj.name;
        }
      },
      birthday() {
        let time = this.params.birthday;

        return this.$global.format(time, "yyyy-MM-dd");
      },
      sheng() {
        return this.cityList.filter(item => {
          return item.level === 1;
        });
      },
      shi: function () {
        return this.cityList.filter(item => {
          return item.parentId === this.sheng[0].id;
        });
      }
    },
    methods: {
      ...mapActions([
        "getDictionaryList",
        "getMemberTypeList",
        "getBranchsList",
        "getZhiChengList",
        "getCityList"
      ]),
      afterTitleFile(fileObj) {
        let params = new FormData();
        params.append("file", fileObj.file);
        uploadFile(params).then(res => {
          if (res.success) {
            this.params.titleFileId = res.result.id;
            Toast("上传成功");
          } else {
            Toast("上传失败");
          }
        });
      },
      afterPortraitFile(fileObj) {
        let params = new FormData();
        params.append("file", fileObj.file);
        uploadFile(params).then(res => {
          if (res.success) {
            this.params.portraitId = res.result.id;
            Toast("上传成功");
          } else {
            Toast("上传失败");
          }
        });
      },
      delFile(type) {
        let id = this.params[type];
        if (id) {
          let params = {
            id
          };

          delFile(params).then(res => {
            if (res.success) {
              Toast("删除成功");
            } else {
              Toast("删除失败");
            }
          });
        }
      },
      getName(list, type) {
        let id = this.params[type];

        if (!id && id !== 0) {
          return "内容";
        } else {
          let obj = null;

          if (type === "recommendUnitId" || type === "concernUnitId") {
            obj = this[list].find(item => item.code == id);
          } else if (type === "title") {
            let group = this[list].find(item => item.value === this.titleGroup);
            let obj = group.children.find(item => item.value === id);

            return obj.label;
          } else {
            obj = this[list].find(item => item.value === id);
          }
          return obj.name;
        }
      },
      setCity(name, key) {
        let obj = this.$refs.picker;
        this.selectModel = true;
        this.key = key;
        this.selectKey = name;

        if (obj) {
          this.$refs.picker.setIndexes([0, 0]);
        }

        this.columns = [
          {
            values: this.sheng,
            className: "column1"
          },
          {
            values: this.shi,
            className: "column2"
          }
        ];
      },
      setSelectModel(type, key, selectKey, ismore) {
        let obj = this.$refs.picker;
        this.selectModel = true;
        this.key = key;
        this.selectKey = selectKey;

        if (obj) {
          this.$refs.picker.setIndexes([0, 0]);
        }
        //是否多级
        if (ismore) {
          this.columns = [
            {
              values: this[type],
              className: "column1"
            },
            {
              values: this[type][0].children,
              className: "column2"
            }
          ];
        } else {
          this.columns = this[type];
        }
      },
      onChange(picker, values, index) {
        if (this.selectKey === "title") {
          picker.setColumnValues(1, values[0].children || []);
        } else if (this.selectKey === "jg" || this.selectKey === "add") {
          let city = this.cityList.filter(item => {
            return item.parentId === values[0].id;
          });
          if (index === 0) {
            picker.setColumnValues(1, city);
          }
        }
      },
      onConfirm(item) {
        this.selectModel = false;
        if (this.selectKey === "memberType") {
          this.params.memberType = item.memberType;
        } else if (
          this.selectKey === "recommendUnitId" ||
          this.selectKey === "concernUnitId"
        ) {
          this.params[this.selectKey] = item.code;
        } else if (this.selectKey === "title") {
          this.titleGroup = item[0].value;
          this.params[this.selectKey] = item[1] ? item[1].value : "";
        } else if (this.selectKey === "jg") {
          this.params.nativeProvince = item[0].value;
          this.params.nativeCity = item[1] ? item[1].value : "";
          this.jgName = item[0].name + item[1].name;
        } else if (this.selectKey === "add") {
          this.params.province = item[0].value;
          this.params.city = item[1] ? item[1].value : "";
          this.addName = item[0].name + item[1] ? item[1].name : "";
        } else {
          this.params[this.selectKey] = item.value;
        }
      },
      onCancel() {
        this.selectModel = false;
      },
      onConfirmDate(time) {
        this.params.birthday = time;
        this.selectModel = false;
      },
      next() {
        let params = {
          ...this.member,
          ...this.params
        };

        for (let item in this.request) {
          if (!this.params[item] || !("" + this.params[item]).length) {
            Toast(this.request[item]);
            return;
          }
        }

        Toast.loading({
          mask: true,
          duration: 0,
          message: "加载中..."
        });

        params.birthday = this.birthday;
        registerMemberEdit(params)
          .then(res => {
            if (res) {
              this.$emit("sendActive", 2);
            } else {
              Toast(res.message || "操作失败");
            }
          })
          .catch(res => {
            Toast.error("操作失败!");
          })
          .finally(() => {
            Toast.clear();
          });
      }
    },
    mounted() {
      this.getDictionaryList();
      this.getMemberTypeList();
      this.getBranchsList();
      this.getZhiChengList();
      this.getCityList();
      window.scrollTo(0, 0);
    }
  };
</script>

<style lang="less" scoped>
  h3 {
    display: flex;
    margin-top: 25px;
    font-size: 16px;
    align-items: center;

    i {
      margin-right: 6px;
    }
  }

  h4 {
    font-size: 14px;
    line-height: 2;

    span {
      display: inline-block;
      margin-left: 10px;
      color: #d64a4a;
    }
  }

  .base-item {
    margin-top: 10px;
  }

  .input-item {
    padding: 0 0 0 0.35rem;
    padding-bottom: 12px;
    border-bottom: 1px solid #dfdfdf;
  }

  .warm {
    margin-top: 3px;
    color: #d64a4a;
    font-size: 12px;
  }

  .nextBtn {
    margin-top: 35px;
  }
</style>